import { Component, Input, OnDestroy, ViewChild } from '@angular/core';

import { IUserTag } from 'rev-portal/media/videos/videoPlayback/inThisVideo/IUserTag';
import { InThisVideoEntryLayout } from 'rev-portal/media/videos/videoPlayback/inThisVideo/InThisVideoEntryAngular.Component';
import { VideoUserTagsService } from 'rev-portal/media/videos/videoPlayback/inThisVideo/VideoUserTags.Service';

import { VbFlickityCarouselComponent } from 'rev-shared/ui/flickityCarousel/VbFlickityCarousel.AngularComponent';

import styles from './PulseInVideoCarousel.module.less';
@Component({
	selector: 'pulse-in-video-carousel',
	templateUrl: './PulseInVideoCarousel.Component.html'
})
export class PulseInVideoCarouselComponent implements OnDestroy {
	@Input() public currentTimeSec: number;
	@ViewChild('carousel') public carousel: VbFlickityCarouselComponent;

	public readonly styles = styles;
	public readonly InThisVideoEntryLayout = InThisVideoEntryLayout;
	public readonly flickityConfig = {
		cellAlign: 'left',
		contain: true,
		draggable: false,
		groupCells: true,
		pageDots: false,
		prevNextButtons: false,
		setGallerySize: false
	};

	constructor(
		public VideoUserTags: VideoUserTagsService
	) { }

	public ngOnDestroy(): void {
		this.VideoUserTags.clearActiveUserTag();
	}

	public onEntryToggle(tag: IUserTag): void {
		this.VideoUserTags.toggleActiveUserTag(tag);
	}
}
